module.exports = __webpack_public_path__ + "static/sarah.88f251bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/master_class/sarah.png
// module id = 572
// module chunks = 149428911916780